import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TypeComponent {
  @Input() mode: string;
}
